import React, { useEffect, useState } from 'react';
import { Helpers } from '@utils/helpers';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import { useTheme, ITheme } from 'src/theme';
import ContainerBlock from '@components/ContainerBlock';
import Link from '@components/Link';
import Heading from '@components/Heading';
import Text from '@components/Text';
import Divider from '@components/Divider';
import Icon from '@components/Icon';

const FlexRow = styled.div<{ margin: string }>`
  display: flex;
  align-items: flex-start;
  margin: ${props => props.margin};
  
`

const custom = css`
  margin-right: 23px;
  
`;

export interface BeforeProcessWarningProps {
  theme?: ITheme;
  margin: number | string;
  isShowExplaination: boolean;
  totalPremium: number;
  insuranceEstimatorUrl?: string;
  budgetCalculatorUrl?: string;
  compareFirstUrl?: string;
}

function BeforeProcessWarning({ margin, isShowExplaination, totalPremium, insuranceEstimatorUrl, budgetCalculatorUrl, compareFirstUrl }: BeforeProcessWarningProps) {
  const theme: ITheme = useTheme();
  const [total, setTotalPremium] = useState<number>(0); 
  useEffect(() => {
    if (totalPremium !== total) {
      setTotalPremium(totalPremium);
    }
  }, [totalPremium, total])
  return (
    <ContainerBlock margin={margin}>
      <Heading variant="sub" fontWeight={600} margin="0 0 15px"> Before you proceed... </Heading>
      <Divider margin="0 0 30px" />
      <FlexRow margin="0 0 38px">
        <Icon className={custom} size="dlg" name="tools-and-calculator-badge" />
        <Text margin="8px 0 0">Use the <Link target="_blank" rel="noopener noreferrer" url={insuranceEstimatorUrl} text="Insurance Estimator" fontWeight="bold" /> calculator to decide the amount of life insurance coverage you would need.</Text>
      </FlexRow>
      <FlexRow margin="0 0 38px">
        <Icon className={custom} size="dlg" name="tools-and-calculator-badge" />
        <Text margin="8px 0 0"><Link text="Check" fontWeight="bold" target="_blank" rel="noopener noreferrer" url={budgetCalculatorUrl} /> if the premium that you will pay is affordable based on your current income and expenditure. </Text>
      </FlexRow>
      <FlexRow margin="0 0 30px">
        <Icon className={custom} size="dlg" name="compare-badge" />
        <Text margin="8px 0 0"><Link text="Compare" fontWeight="bold" target="_blank" rel="noopener noreferrer" url={compareFirstUrl} /> the features and premiums of Direct Purchase Insurance (DPI) and other types of life policies. </Text>
      </FlexRow>
      <Text margin="0 0 40px">Consider the different types of DPI and other types of life policies that are available, and whether the life policy that you intend to purchase is suitable for your financial circumstances and needs.</Text>
      {isShowExplaination && (
        <ContainerBlock padding={20} paddingTablet="20px 30px" background={theme.colors.grey[200]} margin="0 0 40px">
          <Text>The total premium payable for the first policy year is <b>{Helpers.toCurrency(total)}</b>. As this is an yearly renewable term policy, the premium payable for subsequent policy years may not be the same. For the premium payable for each policy year, please refer to the tables in the Policy Illustration (within Declaration section).</Text>
        </ContainerBlock>
      )}
    </ContainerBlock>
  );
};

BeforeProcessWarning.defaultProps = {
  margin: '0 0 40px',
  isShowExplaination: false,
  totalPremium: 0
}

export default BeforeProcessWarning;
